import { SelectionSummary} from 'components/ScalarSpreadsheet/hooks/useSelectionSummary';

const COUNT_LABEL = 'Count';
const SUM_LABEL = 'Sum';
const AVG_LABEL = 'Avg';
const MIN_LABEL = 'Min';
const MAX_LABEL = 'Max';

const COUNT_KEY = 'count';
const SUM_KEY = 'sum';
const AVG_KEY = 'average';
const MIN_KEY = 'min';
const MAX_KEY = 'max';

export const SELECTION_SUMMARY_BAR_ITEMS: {
  label: string;
  key: keyof SelectionSummary;
}[] = [
  { label: COUNT_LABEL, key: COUNT_KEY },
  { label: SUM_LABEL, key: SUM_KEY },
  { label: AVG_LABEL, key: AVG_KEY },
  { label: MIN_LABEL, key: MIN_KEY },
  { label: MAX_LABEL, key: MAX_KEY },
];
